export function isRteMarkupEmpty(markup: string | null | undefined): boolean {
    if (!markup) {
        return true;
    }

    return markup.replace(/<[^>]*>/g, "").replace(/&nbsp;/gi, "").trim().length === 0;
}
